export default {
  // 公共头部
  publicHeader: {
    url: '/mall/headMessage/getHeadMessage',
    type: 'get'
  }
}
